import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, FormGroup, Validators} from '@angular/forms';
import {AbstractBffApi} from '../../models/sharedinterface';
import {ApiFactoryService} from '../../shared/services/api-factory.service';
import {ActivatedRoute} from '@angular/router';
import * as CryptoJS from 'crypto-js';
import {GlobalsService} from '../../shared/services/globals.service';
import {CrudUserService} from '@shared/services/crud-user.service';

@Component({
  selector: 'app-unblock-user-view',
  templateUrl: './unblock-user-view.component.html',
  styleUrls: ['./unblock-user-view.component.scss']
})
export class UnblockUserViewComponent implements OnInit {

  public unblocked = false;
  public error: string;

  public username: string;

  bffapi: AbstractBffApi;

  constructor(protected userCrudService: CrudUserService, private fb: UntypedFormBuilder, private apifactory: ApiFactoryService, protected route: ActivatedRoute,
              private globalsservice: GlobalsService) {
    this.bffapi = this.apifactory.createBffApi();
  }

  ngOnInit(): void {

    const token = this.route.snapshot.paramMap.get('token');

    // Send token and userid to API for unblocking
    this.userCrudService.unblockUserWithToken(token).subscribe(response => {
      const res = response.results;
      this.username = res.username;
      this.error = undefined;
      this.unblocked = true;
    }, error => {
      if (error.status === 400) {// Bad request - should never happen cause there is a validator on the service)
        this.error = 'Wrong user or invalid token. Please contact your administrator.';
      } else if (error.status === 0) {// service not responding
        this.error = 'Network error. Please try again later.';
      } else {
        this.error = 'Error. Please try again later.';
      }
    });

  }

}
